import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '唱响主旋律，奋进新时代';

const route: RouteConfig = {
  path: '/20200120NHHD',
  name: 'NHHD',
  component: () => import('./Home.vue'),
  // redirect: '/2019FMXY/Welcome',
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: '1',
      component: () => import('./1.vue'),
      name: 'One',
      meta: {
        title: PAGE_TITLE,
        keepAlive: false,
      },
    },
    {
      path: '2',
      component: () => import('./2.vue'),
      name: 'Two',
      meta: {
        title: PAGE_TITLE,
        keepAlive: true,
      },
    },
    {
      path: '3',
      component: () => import('./3.vue'),
      name: 'Three',
      meta: {
        title: PAGE_TITLE,
        keepAlive: true,
      },
    },
    {
      path: '4',
      component: () => import('./4.vue'),
      name: 'Four',
      meta: {
        title: PAGE_TITLE,
        keepAlive: true,
      },
    },
    {
      path: '6',
      component: () => import('./6.vue'),
      name: 'Six',
      meta: {
        title: PAGE_TITLE,
        keepAlive: true,
      },
    },
    {
      path: 'detail',
      component: () => import('./Detail.vue'),
      name: 'detail',
      meta: {
        title: PAGE_TITLE,
        keepAlive: false,
      },
    },
    {
      path: 'selection',
      component: () => import('./Selection.vue'),
      name: 'selection',
      meta: {
        title: PAGE_TITLE,
        keepAlive: false,
      },
    },
  ],
};

export default route;
